const a = typeof FormData < "u" ? FormData : null;
export {
  a as default
};
